
import React, { Component } from 'react';
import './stars.css';

export class Stars extends Component{
  constructor(props){
    super(props);
    this.onStarClick = this.onStarClick.bind(this);
    this.onStarHover = this.onStarHover.bind(this);
    this.onStarLeave = this.onStarLeave.bind(this);
    this.state = {
      rating: props.rating || 0,
      hover: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      rating: nextProps.rating
    });
  }

  notifyRatingChanged(value) {
    if (this.props.notifyRatingChanged !== undefined) {
      this.props.notifyRatingChanged(value);
    }
    return true;
  }

  onStarClick(value) {
    if(value === this.state.rating) {
      this.notifyRatingChanged(0);
      this.setState({rating: 0});
    } else {
      this.notifyRatingChanged(value);
      this.setState({rating: value});
    }
  }

  onStarHover(value) {
    this.setState({hover: value});
  }

  onStarLeave() {
    this.setState({hover: 0});
  }

  render() {
    return (
      <div className="DetailDiv Stars marginTop10">
      <div title="Klicke auf einen Stern, um zu bewerten!" className="" onMouseLeave={this.onStarLeave} >
        <h2>
          <span className="Starlet" onClick={ () => this.onStarClick(1) } onMouseLeave={this.onStarLeave} onMouseEnter={ () => this.onStarHover(1) } style={ (this.state.hover >= 1 || this.state.rating >= 1) ? { color: '#1F6A81' } : { color: 'lightgrey' } }>&#9733;</span>
          <span className="Starlet" onClick={ () => this.onStarClick(2) } onMouseLeave={this.onStarLeave} onMouseEnter={ () => this.onStarHover(2) } style={ (this.state.hover >= 2 || this.state.rating >= 2) ? { color: '#1F6A81' } : { color: 'lightgrey' } }>&#9733;</span>
          <span className="Starlet" onClick={ () => this.onStarClick(3) } onMouseLeave={this.onStarLeave} onMouseEnter={ () => this.onStarHover(3) } style={ (this.state.hover >= 3 || this.state.rating >= 3) ? { color: '#1F6A81' } : { color: 'lightgrey' } }>&#9733;</span>
          <span className="Starlet" onClick={ () => this.onStarClick(4) } onMouseLeave={this.onStarLeave} onMouseEnter={ () => this.onStarHover(4) } style={ (this.state.hover >= 4 || this.state.rating >= 4) ? { color: '#1F6A81' } : { color: 'lightgrey' } }>&#9733;</span>
          <span className="Starlet" onClick={ () => this.onStarClick(5) } onMouseLeave={this.onStarLeave} onMouseEnter={ () => this.onStarHover(5) } style={ (this.state.hover >= 5 || this.state.rating >= 5) ? { color: '#1F6A81' } : { color: 'lightgrey' } }>&#9733;</span>
        </h2>
        <div className="FontXsmall textAlignCenter">{this.state.rating} von 5 Sternen</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stars.js